import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DialogHeader from './DialogHeader'
import { useTranslation } from 'react-i18next'
import SearchUserVMP from 'components/common/SearchUserVMP'
import { toastError, toastInfo, toastWarning } from 'utils/helpers'
import apiManagerSubtitles from 'api/manager-subtitles'
import ListParticipantsShare from 'pages/subtitles/components/ListParticipantsShare'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ROLE } from 'pages/subtitles/components/constants'
import { CustomSortArray } from 'utils/functions/participant'
import ListParticipantsShareRoom from 'pages/manager-meeting/components/ListParticipantsShareRoom'

const DialogShareToParticipants = ({ onCancel, onClose, titleKey = 'subtitles.popup.share.title', live_captions_id,
    onSubmit,
    userList = [],
    roleParticipant = ROLE.PARTICIPANT,
    useListParticipantsShareRoom = false,
    userIdList = [],
    title = 'subtitles.popup.share.title',
    maxTotalPeople,
    currentTotalPeople,
    titleListParticipant = 'subtitles.popup.share.shared-participant',
    fetchListUserInvited = false }) => {
    const { t } = useTranslation()
    const [userListRender, setUserListRender] = useState(userList);
    const firstUserListRender = userList;
    const [usernameList, setUsernameList] = useState([]);

    const handleClose = () => {
        onClose()
        onCancel && onCancel()
    }

    const getListSharedPeopleById = (id) => {
        return apiManagerSubtitles.getListSharedPeopleById(id);
    };

    const handleChangeDataParticipant = (dataParticipant) => {
        if (!dataParticipant?.isDeleted) {
            const findHostUser = userListRender?.find(user => user.role === ROLE.HOST);
            if (findHostUser && dataParticipant?.role === ROLE.HOST) {
                toastInfo(t('validate.only-one-host'))
            } else {
                setUserListRender(prevData => (
                    CustomSortArray([...prevData?.filter(part => part?.id !== dataParticipant?.id), { ...dataParticipant, name: dataParticipant?.name, role: dataParticipant?.role }])
                ))
            }
        } else {
            setUserListRender(prevData => prevData?.filter(part => part?.id !== dataParticipant?.id));
        }
    }

    const handleAction = () => {
        if ((title === "meeting.popup.title-invite-operator" || title === "meeting.popup.title-invite-par") && (userListRender.length + currentTotalPeople) > maxTotalPeople) {
            if ((currentTotalPeople + firstUserListRender.length) >= maxTotalPeople) {
                toastWarning(t('validate.max-people'))
            } else {
                toastWarning(t('validate.max-n-people', { number: maxTotalPeople - (firstUserListRender.length + currentTotalPeople) }))
            }
        } else {
            const idsUser = userListRender?.map(user => user.id || user.accId)
            onSubmit(live_captions_id, idsUser, userListRender);
            onClose()
        }
    }

    const handleOpenModalShareSubtitles = () => {

    }

    useEffect(() => {
        if (fetchListUserInvited) {
            getListSharedPeopleById(live_captions_id)
                .then((response) => {
                    setUserListRender(response?.records);
                    setUsernameList(response?.records?.map(record => record?.accId))
                })
                .catch((e) => {
                    toastError(t('toast.errorServer'));
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Dialog id='share-to-participants' open onClose={handleClose} fullWidth maxWidth={'md'}>
            <DialogHeader titleKey={titleKey} onClose={handleClose} />
            <DialogContent>
                <Box mt={2}>
                    <Typography mb={1}>{t('subtitles.popup.share.account')}</Typography>
                    <SearchUserVMP
                        userListRender={userListRender}
                        setUserListRender={setUserListRender}
                        userIdList={usernameList.length > 0 ? usernameList : userIdList}
                        roleParticipant={roleParticipant}
                    />
                </Box>
                <Box mt={3}>
                    <Typography mb={1}>{t(titleListParticipant)} ({userListRender?.length})</Typography>
                    {
                        useListParticipantsShareRoom ?
                            (
                                <ListParticipantsShareRoom
                                    userListRender={userListRender}
                                    setChangeDataParticipant={handleChangeDataParticipant}
                                    style={{ borderRadius: '4px', border: '1px solid #AAA', padding: '5px 10px 5px 0', height: '162px' }}
                                    t={t}
                                    addPeople={true}
                                    handleOpenModalShareSubtitles={handleOpenModalShareSubtitles}
                                    hideAddButton={true}

                                />
                            ) :
                            (
                                <ListParticipantsShare t={t} userListRender={userListRender} setChangeDataParticipant={handleChangeDataParticipant} />
                            )
                    }
                </Box>
                {!useListParticipantsShareRoom &&
                    <div className="share-subtitle-content share-subtitle-content-info">
                        <InfoOutlinedIcon sx={{ marginRight: '10px' }} />
                        <Typography>{t('subtitles.popup.share.noti')}</Typography>
                    </div>
                }
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose}>{t('actions.cancel')}</Button>
                <Button disabled={userListRender?.length <= 0} onClick={handleAction}>{t('subtitles.popup.share.share')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogShareToParticipants